/**
 * Companies API slice.
 * Leaf module (Perf 3.1.b/e Step 5). Pulls only the shared chokepoint from
 * ./client; never imports a sibling @/lib/api slice.
 */
import { fetchWithAuth, ApiError } from './client';

export const companiesApi = {
  getModelCompanies: async () => {
    const data = await fetchWithAuth('/json/models/companies');
    
    if (data.error) {
      throw new ApiError(data.message || 'Failed to fetch model companies', 400, data);
    }
    
    return data.companies;
  },

  getModelsByCompanies: async (page = 1, limit = 10, modelsLimit = 9) => {
    try {
      const data = await fetchWithAuth(`/json/models-by-companies?page=${page}&limit=${limit}&modelsLimit=${modelsLimit}`);
      
      if (data.error) {
        throw new ApiError(data.message || 'Failed to fetch companies with models', 400, data);
      }
      
      return {
        companies: data.companies,
        pagination: data.pagination
      };
    } catch (error) {
      console.error('Error fetching companies with models:', error);
      throw error;
    }
  },

  // Get models for a specific company
  getModelsByCompany: async (companyId, page = 1) => {
    try {
      const data = await fetchWithAuth(`/json/companies/${companyId}/models?page=${page}`);

      if (data.error) {
        throw new ApiError(data.message || 'Failed to fetch models for company', 400, data);
      }

      return {
        company: data.company,
        models: data.models,
        pagination: data.pagination
      };
    } catch (error) {
      console.error('Error fetching models for company:', error);
      throw new ApiError(
        error.message || 'Failed to fetch models for company',
        error.status,
        error.data
      );
    }
  },

  // ... rest of the methods ...
};
